/* Windows 95 Login Functionality */

class Windows95Login {
  constructor() {
    // Configuration - CHANGE THESE VALUES
    this.config = {
      password: 'FUCKGHE2026', // Change this to your desired password
      sessionDuration: 24, // Hours before requiring re-login
      storageKey: 'win95_session',
      rememberMeKey: 'win95_remember',
      maxAttempts: 5, // Max failed login attempts before lockout
      lockoutDuration: 5 // Minutes of lockout after max attempts
    };

    this.loginAttempts = 0;
    this.lockoutUntil = null;
    
    this.init();
  }

  init() {
    // Check if already logged in
    if (this.isLoggedIn()) {
      this.hideLoginScreen();
      return;
    }

    // Create and show login screen
    this.createLoginScreen();
    this.setupEventListeners();
    
    // Check for lockout
    this.checkLockout();
  }

  createLoginScreen() {
    // Check if login screen already exists
    if (document.getElementById('win95-login-screen')) {
      return;
    }

    const loginScreen = document.createElement('div');
    loginScreen.id = 'win95-login-screen';
    loginScreen.className = 'win95-login-screen';
    
    loginScreen.innerHTML = `
      <div class="win95-login-logo">
  <img src="https://cdn.shopify.com/s/files/1/0577/5769/6088/files/logo_76c134a7-171f-40b3-a022-4ca9c5a95133.png?v=1767842619" alt="Logo" style="max-height: 80px; margin-bottom: 8px;">
  <div class="win95-logo-subtext">Windows 95 experience</div>
</div>

      <div class="win95-login-dialog">
        <div class="win95-login-title-bar">
          <div class="win95-login-title-text">
            <span>🔒</span>
            Enter Password
          </div>
        </div>

        <div class="win95-login-content">
          <svg class="win95-login-icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="22" fill="#808080" stroke="#000" stroke-width="2"/>
            <circle cx="24" cy="18" r="8" fill="#C0C0C0"/>
            <path d="M10 40 Q10 28 24 28 Q38 28 38 40" fill="#C0C0C0"/>
          </svg>

          <div class="win95-login-message">
            <strong>Welcome!</strong>
            Please enter your password to access the shop.
          </div>

          <div class="win95-login-error" id="login-error"></div>
          
          <div class="win95-login-loading" id="login-loading"></div>

          <form class="win95-login-form" id="win95-login-form">
            <div class="win95-login-field">
              <label for="win95-password">Password:</label>
              <input 
                type="password" 
                id="win95-password" 
                name="password" 
                class="win95-login-input"
                autocomplete="current-password"
                required
              >
            </div>

            <div class="win95-login-checkbox-group">
              <input 
                type="checkbox" 
                id="win95-remember" 
                name="remember" 
                class="win95-login-checkbox"
              >
              <label for="win95-remember" class="win95-login-checkbox-label">
                Remember me
              </label>
            </div>

            <div class="win95-login-buttons">
              <button type="submit" class="win95-login-button win95-login-button-primary">
                OK
              </button>
              <button type="button" class="win95-login-button" id="win95-cancel-btn">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="win95-login-footer">
        Press Ctrl+Alt+Del for help
      </div>
    `;

    document.body.appendChild(loginScreen);

    // Create welcome message element (hidden initially)
    const welcomeMsg = document.createElement('div');
    welcomeMsg.id = 'win95-welcome';
    welcomeMsg.className = 'win95-welcome-message';
    welcomeMsg.innerHTML = `
      <h2>Welcome to Windows 95</h2>
      <p>Loading your shopping experience...</p>
    `;
    document.body.appendChild(welcomeMsg);
  }

  setupEventListeners() {
    const form = document.getElementById('win95-login-form');
    const cancelBtn = document.getElementById('win95-cancel-btn');
    const passwordInput = document.getElementById('win95-password');

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.handleLogin();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        this.handleCancel();
      });
    }

    // Auto-focus password field
    if (passwordInput) {
      setTimeout(() => passwordInput.focus(), 100);
    }

    // Easter egg: Ctrl+Alt+Del shows hint
    document.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.altKey && e.key === 'Delete') {
        e.preventDefault();
        this.showPasswordHint();
      }
    });
  }

  handleLogin() {
    const passwordInput = document.getElementById('win95-password');
    const rememberCheckbox = document.getElementById('win95-remember');
    const errorDiv = document.getElementById('login-error');
    const loadingDiv = document.getElementById('login-loading');
    const form = document.getElementById('win95-login-form');

    // Check if locked out
    if (this.isLockedOut()) {
      this.showError('Too many failed attempts. Please try again later.');
      return;
    }

    const password = passwordInput.value;
    const remember = rememberCheckbox.checked;

    // Show loading state
    if (form) form.style.display = 'none';
    if (loadingDiv) loadingDiv.classList.add('active');
    if (errorDiv) errorDiv.classList.remove('active');

    // Simulate loading delay for authenticity
    setTimeout(() => {
      if (this.validatePassword(password)) {
        // Success!
        this.loginAttempts = 0;
        this.setSession(remember);
        this.showWelcomeMessage();
        
        setTimeout(() => {
          this.hideLoginScreen();
        }, 1500);
      } else {
        // Failed login
        this.loginAttempts++;
        
        if (loadingDiv) loadingDiv.classList.remove('active');
        if (form) form.style.display = 'block';
        
        if (this.loginAttempts >= this.config.maxAttempts) {
          this.setLockout();
          this.showError(`Too many failed attempts. Locked out for ${this.config.lockoutDuration} minutes.`);
        } else {
          const remaining = this.config.maxAttempts - this.loginAttempts;
          this.showError(`Incorrect password. ${remaining} attempt(s) remaining.`);
        }
        
        passwordInput.value = '';
        passwordInput.focus();
      }
    }, 800);
  }

  validatePassword(password) {
    return password === this.config.password;
  }

  setSession(remember) {
    const now = new Date();
    const expiry = new Date(now.getTime() + (this.config.sessionDuration * 60 * 60 * 1000));
    
    const sessionData = {
      loggedIn: true,
      expiry: expiry.toISOString()
    };

    if (remember) {
      localStorage.setItem(this.config.storageKey, JSON.stringify(sessionData));
      localStorage.setItem(this.config.rememberMeKey, 'true');
    } else {
      sessionStorage.setItem(this.config.storageKey, JSON.stringify(sessionData));
    }
  }

  isLoggedIn() {
    // Check both session and local storage
    const sessionData = sessionStorage.getItem(this.config.storageKey);
    const localData = localStorage.getItem(this.config.storageKey);
    const rememberMe = localStorage.getItem(this.config.rememberMeKey);

    let data = null;
    if (rememberMe === 'true' && localData) {
      data = localData;
    } else if (sessionData) {
      data = sessionData;
    }

    if (!data) return false;

    try {
      const session = JSON.parse(data);
      const expiry = new Date(session.expiry);
      const now = new Date();

      if (now < expiry) {
        return true;
      } else {
        // Session expired
        this.logout();
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  logout() {
    sessionStorage.removeItem(this.config.storageKey);
    localStorage.removeItem(this.config.storageKey);
    localStorage.removeItem(this.config.rememberMeKey);
    
    // Reload page to show login
    window.location.reload();
  }

  setLockout() {
    const now = new Date();
    const lockoutUntil = new Date(now.getTime() + (this.config.lockoutDuration * 60 * 1000));
    localStorage.setItem('win95_lockout', lockoutUntil.toISOString());
    this.lockoutUntil = lockoutUntil;
  }

  checkLockout() {
    const lockoutData = localStorage.getItem('win95_lockout');
    if (!lockoutData) return;

    const lockoutUntil = new Date(lockoutData);
    const now = new Date();

    if (now < lockoutUntil) {
      this.lockoutUntil = lockoutUntil;
      const remainingMinutes = Math.ceil((lockoutUntil - now) / 1000 / 60);
      this.showError(`Account locked. Try again in ${remainingMinutes} minute(s).`);
      
      // Disable form
      const form = document.getElementById('win95-login-form');
      if (form) {
        const inputs = form.querySelectorAll('input, button');
        inputs.forEach(input => input.disabled = true);
      }
    } else {
      // Lockout expired
      localStorage.removeItem('win95_lockout');
      this.lockoutUntil = null;
    }
  }

  isLockedOut() {
    if (!this.lockoutUntil) return false;
    const now = new Date();
    return now < this.lockoutUntil;
  }

  showError(message) {
    const errorDiv = document.getElementById('login-error');
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.classList.add('active');
    }
  }

  showWelcomeMessage() {
    const welcomeMsg = document.getElementById('win95-welcome');
    if (welcomeMsg) {
      welcomeMsg.classList.add('active');
      setTimeout(() => {
        welcomeMsg.classList.remove('active');
      }, 1500);
    }
  }

  hideLoginScreen() {
    const loginScreen = document.getElementById('win95-login-screen');
    if (loginScreen) {
      loginScreen.classList.add('hidden');
    }
  }

  handleCancel() {
    // Optional: redirect to another page or show message
    const errorDiv = document.getElementById('login-error');
    if (errorDiv) {
      errorDiv.textContent = 'You must log in to access this site.';
      errorDiv.classList.add('active');
    }
  }

  showPasswordHint() {
    alert('Password hint: The default password is "windows95". Change this in the JavaScript file!');
  }

  // Public method to add logout button to page
  static addLogoutButton() {
    const logoutBtn = document.createElement('button');
    logoutBtn.className = 'win95-button';
    logoutBtn.textContent = 'Logout';
    logoutBtn.style.cssText = 'position: fixed; top: 10px; right: 10px; z-index: 10000;';
    logoutBtn.onclick = () => {
      const login = new Windows95Login();
      login.logout();
    };
    document.body.appendChild(logoutBtn);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new Windows95Login();
  });
} else {
  new Windows95Login();
}

// Export for external use
window.Windows95Login = Windows95Login;
